import axios from 'axios';

// ACTION TYPES
const name = 'data';
export const actionTypes = {
  STRATEGIES: `${name}:strategies`,
};
// Temporary safety block: this test email is still used by another config and
// we must prevent this dashboard from calling /personalstrategies for it.
// RD: in prod, landing on advisor dashboard this email initially hits. Havn't found the source so this is a temp block
const BLOCKED_PERSONAL_STRATEGIES_EMAILS = [
  'wttest29082019advisor@test.com',
];

function isBlockedPersonalStrategiesEmail(clientEmail = '') {
  return BLOCKED_PERSONAL_STRATEGIES_EMAILS.includes(clientEmail.trim().toLowerCase());
}

// ACTIONS
export function loadPersonalStrategies() {
  return (dispatch, getState) => {
    const clientEmail = getState().params.clientEmail || '';
    if (isBlockedPersonalStrategiesEmail(clientEmail)) {
      dispatch({ type: actionTypes.STRATEGIES, value: [] });
      return Promise.resolve();
    }

    const request = {
      method: 'GET',
      url: `${getState().params.apiUrl}/personalstrategies/`,
      params: {
        clientEmail,
      },
      headers: {
        Authorization: getState().params.token && `Token ${getState().params.token}`,
      },
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: actionTypes.STRATEGIES, value: response.data });
      })
      .catch((error) => {
        console.error(error);
      });
  };
}
